export const validateVinCode = (vinCode, t) => {
    if (vinCode.length !== 17) {
        return {
            result: false,
            title: t('jobs:notifications.invalidVinLength.title'),
            description: t('jobs:notifications.invalidVinLength.description'),
        };
    }

    if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(vinCode)) {
        return {
            result: false,
            title: t('jobs:notifications.invalidVinFormat.title'),
            description: t('jobs:notifications.invalidVinFormat.description'),
        };
    }

    return {
        result: true,
    };
};
